module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/main/content/activos/components/powerbi-tabla/powerbi-tabla.component.scss
// module id = ./src/app/main/content/activos/components/powerbi-tabla/powerbi-tabla.component.scss
// module chunks = main